import React from "react";
import { Select, Form, Icon, Input, Button, Row, Col, DatePicker } from "antd";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import find from "lodash/find";
import lowerCase from "lodash/lowerCase";
import FileLink from "../FileLink/FileLink";

const { Option } = Select;

const getIsActive = (by_person_settings, type, names) => {
  // TODO, ultimately the whole form can be rendered from the data in by_person_settings without needing this function
  // example is in src/components/ConsentTypeMevoV2/example_consent_by_person_settings.json
  if (!type || !by_person_settings){
    return null;
  }
  let personConsentTypes = get(by_person_settings, `${type}.consent_types`);
  if (personConsentTypes !== undefined) {
    for (const [key, methods] of Object.entries(personConsentTypes)) {
      for (const [typeKey, methodData] of Object.entries(methods)) {
        if (names.includes(get(methodData, `name`)) && get(methodData, `active`)){
          return true;
        }
      }
    }
  }
};

const ConsentMevoStep2 = (props) => {
  let consentPersonType = lowerCase(props.form.getFieldValue("consentPersonType"));
  return (
    <div className="form-group">
      <div className="form-group-details">
        {props.subjectID ? <h4>
          {props.i18n.t(
            "NamespaceConsent:Subject Found! Please verify details below"
          )}
          :
        </h4> : <h4>
          {props.i18n.t(
            "NamespaceConsent:Please verify details below"
          )}
          :
        </h4>}
        {props.siteID && (
          <h5>
            {props.i18n.t("NamespaceConsent:Site ID")}: <b>{props.siteID}</b>
          </h5>
        )}
        {props.userID && (
          <h5>
            {props.i18n.t("NamespaceConsent:User ID")}: <b>{props.userID}</b>
          </h5>
        )}
        <h5>
          {props.i18n.t("NamespaceConsent:Subject ID")}: <b>{props.subjectID}</b>
        </h5>

        <h5>
          {props.i18n.t("NamespaceConsent:Consent Exists")}:{" "}
          <b>{props.consentExists === true ? "Yes" : "No"}</b>
        </h5>

        {props.consentExists && (
          <div className="consent-exists">
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Date")}: <b>{props.consentExistsDate}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Type")}: <b>{props.consentExistsType}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Person")}:{" "}
              <b>{props.consentExistsPersonType}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Method")}:{" "}
              <b>{props.consentExistsMethodType}   {props.consent_upload_later && <span>({props.i18n.t("NamespaceConsent:uploading skipped")})</span>}</b>
            </h5>

            {props.consentExistsMethodType && props.consentExistsMethodType.includes('Email') &&
              props.consentExistsEmailStatus && (
                <h5>
                  {props.i18n.t(
                    "NamespaceConsent:Consent Email Status"
                  )}
                  : <b>{props.consentExistsEmailStatus.replace(/_/g, " ")}</b>
                </h5>
              )}

            {props.consentExistsLink &&
              (Array.isArray(props.consentExistsLink) ? (
                props.consentExistsLink.map(({ link, name }) => (
                  <h5 key={name}>
                    {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
                    <b style={{ position: "relative", top: "8px" }}>
                      <FileLink url={link} text={name} />
                    </b>
                  </h5>
                ))
              ) : (
                <h5>
                  {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
                  <b>
                    <a href={props.consentExistsLink.link} target="_blank">
                      {props.consentExistsLink.name}
                    </a>
                  </b>
                </h5>
              ))}
          </div>
        )}
      </div>
      {props.consent_upload_later &&
        <div className='ant-alert ant-alert-error'>
          <p>{props.i18n.t("Warning:")}{" "}{props.i18n.t('NamespaceConsent:Paper Consent file has not been uploaded. Please upload this file from the workflow below prior to initiating another consent workflow for this subject!')}</p>
        </div>
      }
      {/*# NORMAL SELECT without skipped upload*/}
      {!props.consent_upload_later &&
        <Form.Item>
          <label>
            <span className="form-label">
              {props.i18n.t(
                "NamespaceConsent:Who will be providing Consent?"
              )}
            </span>
            {props.form.getFieldDecorator("consentPersonType", {
              // initialValue: props.consentPersonType || props.consentExistsPersonType,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select who will be providing consent"
                  ),
                },
              ],
            })(
               <Select>
                  <Option value="Patient" disabled={!get(props.by_person_settings, 'patient.active')}>{props.i18n.t("NamespaceConsent:Patient")}</Option>
                  <Option value="Surrogate" disabled={!get(props.by_person_settings, 'surrogate.active')}>{props.i18n.t("NamespaceConsent:Surrogate")}</Option>
                  <Option value="Emergency" disabled={!get(props.by_person_settings, 'emergency.active')}>{props.i18n.t("NamespaceConsent:Emergency")}</Option>
              </Select>
            )}
          </label>
        </Form.Item>
      }
      {!props.consent_upload_later &&
      <Form.Item>
        <label>
          <span className="form-label">{props.i18n.t("NamespaceConsent:Consent Type")}</span>
          {props.form.getFieldDecorator("consentMethodType", {
            // initialValue: props.consentExistsMethodType,
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsent:Please select the type of consent desired"
                ),
              },
            ],
          })(
            <Select>
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient', 'Surrogate', 'Emergency']) &&
              <Option value="Electronic">
                {props.i18n.t("NamespaceConsent:Electronic Consent")}
              </Option>}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient Paper', 'Surrogate Paper', 'Emergency Paper']) &&
                <Option value="Paper">
                {props.i18n.t("NamespaceConsent:Paper Consent")}
              </Option>}

              {getIsActive(props.by_person_settings, consentPersonType, ['Patient Email', 'Surrogate Email', 'Emergency Email']) && (
                <Option value="Email">
                  {props.i18n.t("NamespaceConsent:E-mail Consent")}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Regained Capacity']) && (
                <Option value="RegainedCapacity">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity Electronic"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Regained Capacity Email']) && (
                <Option value="EmailRegainedCapacity">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity Email"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Regained Capacity Paper']) && (
                <Option value="RegainedCapacityPaper">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity Paper"
                  )}
                </Option>
              )}


              {/* props.consentExistsPersonType === 'Emergency' &&   */}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient After Deferral', 'Surrogate After Deferral']) && (
                <Option value="AfterDeferralElectronic">
                  {props.i18n.t(
                    "NamespaceConsent:After Deferral Electronic"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient After Deferral Email', 'Surrogate After Deferral Email']) && (
                <Option value="AfterDeferralEmail">
                  {props.i18n.t(
                    "NamespaceConsent:After Deferral Email"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient After Deferral Deferral Paper', 'Surrogate After Deferral Paper']) && (
                <Option value="AfterDeferralPaper">
                  {props.i18n.t(
                    "NamespaceConsent:After deferral Paper"
                  )}
                </Option>
              )}

              {getIsActive(props.by_person_settings, consentPersonType, ['Patient Regained Capacity After Deferral', 'Surrogate Regained Capacity After Deferral']) && (
                <Option value="RegainedCapacityAfterDeferralElectronic">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity After Deferral Electronic"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient Regained Capacity After Deferral Email', 'Surrogate Regained Capacity After Deferral Email']) && (
                <Option value="RegainedCapacityAfterDeferralEmail">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity After Deferral Email"
                  )}
                </Option>
              )}
              {getIsActive(props.by_person_settings, consentPersonType, ['Patient Regained Capacity After Deferral Paper', 'Surrogate Regained Capacity After Deferral Paper']) && (
                <Option value="RegainedCapacityAfterDeferralPaper">
                  {props.i18n.t(
                    "NamespaceConsent:Regained Capacity After Deferral Paper"
                  )}
                </Option>
              )}

              {/*{props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentElectronic">{props.i18n.t('NamespaceConsent:Withdraw Consent Electronic')}</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentPaper">{props.i18n.t('NamespaceConsent:Withdraw Consent Paper')}</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentEmail">{props.i18n.t('NamespaceConsent:Withdraw Consent Email')}</Option>}*/}
            </Select>
          )}
        </label>
      </Form.Item>
      }

      {!props.consent_upload_later &&
      <Form.Item>
        <label>
          <span className="form-label">{props.i18n.t("NamespaceConsent:Who is collecting the consent?")}</span>
          {props.form.getFieldDecorator("who_is_collecting_consent", {
            // initialValue: props.consentExistsMethodType,
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  props.i18n.t("Required")
                ),
              },
            ],
          })(
            <Select>
              <Option value="investigator">
                            {props.i18n.t("NamespaceConsent:Investigator")}</Option>
              <Option value="other">{props.i18n.t("NamespaceConsent:Other role")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>
      }

      {/*# WHEN prev paper consent was skipped */}
      {props.consent_upload_later &&
        <Form.Item>
          <label>
            <span className="form-label">
              {props.i18n.t(
                "NamespaceConsent:Who will be providing Consent?"
              )}
            </span>
            {props.form.getFieldDecorator("consentPersonType", {
              // initialValue: props.consentPersonType || props.consentExistsPersonType,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select who will be providing consent"
                  ),
                },
              ],
            })(
               <Select>
                 {props.consentExistsPersonType === 'Patient' &&
                  <Option value="Patient" disabled={!get(props.by_person_settings, 'patient.active')}>{props.i18n.t("NamespaceConsent:Patient")}</Option>
                 }
                 {props.consentExistsPersonType === 'Surrogate' &&
                  <Option value="Surrogate" disabled={!get(props.by_person_settings, 'surrogate.active')}>{props.i18n.t("NamespaceConsent:Surrogate")}</Option>
                 }
                 {props.consentExistsPersonType === 'Emergency' &&
                  <Option value="Emergency" disabled={!get(props.by_person_settings, 'emergency.active')}>{props.i18n.t("NamespaceConsent:Emergency")}</Option>
                 }

              </Select>
            )}
          </label>
        </Form.Item>
      }

      {props.consent_upload_later &&
        <Form.Item>
          <label>
            <span className="form-label">{props.i18n.t("NamespaceConsent:Consent Type")}</span>
            {props.form.getFieldDecorator("consentMethodType", {
              // initialValue: props.consentExistsMethodType,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select the type of consent desired"
                  ),
                },
              ],
            })(
                <Select>
                  {getIsActive(props.by_person_settings, lowerCase(props.form.getFieldValue("consentPersonType")), ['Patient Paper (upload missing)', 'Surrogate Paper (upload missing)', 'Emergency Paper (upload missing)']) &&
                    <Option value="Paper">
                      {props.i18n.t("NamespaceConsent:Paper Consent")} <span>({props.i18n.t("NamespaceConsent:upload missing")})</span>
                    </Option>
                  }

                  {getIsActive(props.by_person_settings, lowerCase(props.form.getFieldValue("consentPersonType")), ['NamespaceConsent:Regained Capacity Paper (upload missing)']) && (
                    <Option value="RegainedCapacityPaper">
                      {props.i18n.t(
                        "NamespaceConsent:Regained Capacity Paper"
                      )} <span>({props.i18n.t("NamespaceConsent:upload missing")})</span>
                    </Option>
                )}

                {getIsActive(props.by_person_settings, lowerCase(props.form.getFieldValue("consentPersonType")), ['Patient After Deferral Deferral Paper (upload missing)', 'Surrogate After Deferral Paper (upload missing)']) && (
                  <Option value="AfterDeferralPaper">
                    {props.i18n.t(
                      "NamespaceConsent:After deferral Paper"
                    )} <span>({props.i18n.t("NamespaceConsent:upload missing")})</span>
                  </Option>
                )}

                  {getIsActive(props.by_person_settings, lowerCase(props.form.getFieldValue("consentPersonType")), ['Patient Regained Capacity After Deferral Paper (upload missing)', 'Surrogate Regained Capacity After Deferral Paper (upload missing)']) && (
                  <Option value="RegainedCapacityAfterDeferralPaper">
                    {props.i18n.t(
                      "NamespaceConsent:Regained Capacity After Deferral Paper"
                    )} <span>({props.i18n.t("NamespaceConsent:upload missing")})</span>
                  </Option>
                )}

                </Select>

            )}
          </label>
        </Form.Item>
      }

      <Form.Item>
        <label>
          <span className="form-label">
            {props.i18n.t(
              "NamespaceConsent:Please indicate approval to start the consenting process"
            )}
          </span>
          {props.form.getFieldDecorator("consent_overwrite", {
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsent:You need to agree to override data if you wish to proceed with this entry!"
                ),
              },
            ],
          })(
            <Select>
              <Option value="yes">{props.i18n.t("Yes")}</Option>
              <Option value="">{props.i18n.t("No")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>
    </div>
  );
};

export default withNamespaces()(ConsentMevoStep2);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevoV2/ConsentMevoStep2.js